import React, {useState} from 'react';
import cl from './UserItem.module.css'
import MoreDots from "../MoreDots/MoreDots";
import avatar from "../../../Assets/Avatar.svg"

const UserItem = ({id, name, surname, entity, setData, text, dep}) => {
    const [activeMenuId, setActiveMenuId] = useState(null);

    const toggleMenu = (id) => {
        setActiveMenuId(activeMenuId === id ? null : id);
    };

    return (
        <div className={cl.row}>
            <div className={cl.info}>
                <img src={avatar} alt={"Ava"}/>
                <p className={cl.name}>{name} {surname}</p>
                <p className={cl.additional}>{dep}</p>
                {entity === "students" &&(
                    <p className={cl.additional}>1st year</p>
                )}
            </div>
            <MoreDots
                id={id}
                entity={entity}
                isOpen={activeMenuId === id}
                onToggle={() => toggleMenu(id)}
                setData={setData}
                text={text}
            />
        </div>
    );
};

export default UserItem;